export default __webpack_public_path__ + "static/media/rsz_smiley.7e25d90f.jpg";